import {
  FETCH_ORDER_BY_TOKEN_SUCCESS,
  UPDATE_ORDER_TEMPLATE,
} from '../../constants';

export const orderTemplate = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_ORDER_BY_TOKEN_SUCCESS:
      return payload;
    case UPDATE_ORDER_TEMPLATE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
